import { useState } from "react";
import { motion } from "framer-motion";
import { Shield, PawPrint, CheckCircle } from "@phosphor-icons/react";
import { toast } from "sonner";
import api from "@/lib/api";
import { fbTrack } from "@/lib/fbpixel";

export default function WarriorsSanctuary() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const join = async () => {
    if (!email.includes("@")) return toast.error("Enter a valid email");
    setBusy(true);
    try {
      await api.post("/subscribe", { email, source: "warriors-sanctuary" });
      fbTrack("Lead", { content_name: "newsletter-warriors" });
      setDone(true);
    } catch { toast.error("Couldn't join — try again"); }
    finally { setBusy(false); }
  };

  return (
    <section className="relative overflow-hidden bg-[#050505] border-y border-white/10" data-testid="warriors-sanctuary">
      <div className="absolute inset-0 pointer-events-none opacity-40" style={{ background: "radial-gradient(60% 120% at 50% 100%, rgba(0,229,229,0.16), transparent 60%)" }} />
      <div className="relative max-w-3xl mx-auto px-5 sm:px-8 py-16 text-center">
        <motion.p initial={{ opacity: 0, y: 10 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          className="overline text-secondary mb-3 inline-flex items-center gap-2"><Shield weight="fill" size={15} /> Warrior's Sanctuary</motion.p>
        <h2 className="font-display font-black uppercase tracking-tighter text-3xl sm:text-5xl leading-[0.95] mb-4">
          Join <span className="neon-text">the pack.</span>
        </h2>
        <p className="text-muted-foreground max-w-xl mx-auto mb-8">
          Get "The Pack Dispatch" — rescues saved, ranch progress, and first dibs on every drop. No spam, just the mission.
        </p>
        {done ? (
          <div className="inline-flex items-center gap-2 text-secondary font-modern" data-testid="ws-success">
            <CheckCircle weight="fill" size={22} /> You're in the pack. Watch your inbox. 🐾
          </div>
        ) : (
          <div className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
            <input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com" type="email"
              className="flex-1 bg-transparent border border-white/15 rounded-full px-5 py-3 text-sm outline-none focus:border-secondary" data-testid="ws-email" />
            <button onClick={join} disabled={busy} className="inline-flex items-center justify-center gap-2 bg-secondary text-black px-6 py-3 rounded-full font-modern font-medium disabled:opacity-50" data-testid="ws-join">
              <PawPrint weight="fill" size={16} /> {busy ? "Joining…" : "Join the pack"}
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
